import React from 'react';

import Loader from 'components/Loader';
import ItemPost from 'templates/pages/TemplatePost';

import withPreview from '@/hoc/withPreview';
import { templatePost } from 'constants/graphql/templatePost';

const TemplatePost = ({ pageContext, loaded, ...props }) => {
  if (!loaded) return <Loader />;

  return <ItemPost {...pageContext} {...props} />;
};

const queryPreview = `
query TemplatePostQuery($id: ID = "") {
  templatePost(id: $id, idType: DATABASE_ID, asPreview: true) {
    ${templatePost()}
    revisions(first:1) {
      nodes {
        ${templatePost()}
      }
    }
  }
}
`;

export default withPreview(TemplatePost, {
  queryPreview,
});
